
export default {
  props: {
    openSection: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      openSectionInternal: null
    }
  },
  methods: {
    getSectionColorFor(sectionNumber) {
      return sectionNumber == this.openSectionInternal ? 'resBlue darken-1 white--text' : 'white'
    },
    getIconColorFor(sectionNumber) {
      return sectionNumber == this.openSectionInternal ? 'white' : 'resBlue darken-1'
    },
    openExternalTopic(topic) {
      this.$eventHub.$emit('directToHelp', topic);
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.openSectionInternal = this.openSection
    })
  }
}
